import { withChartLayout } from 'components/common';
import GeriatricDepressionScale from 'components/features/chart/special-charts/geriatric-depression-scale/GeriatricDepressionScale';

const GeriatricDepressionScalePage = withChartLayout('Geriatric Depression Scale')(GeriatricDepressionScale);
export default GeriatricDepressionScalePage;
